import * as React from "react";

const DotOutlineFillIcon = ({ color = "#1F1F1F", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8 5C7.40666 5 6.82664 5.17595 6.33329 5.50559C5.83994 5.83524 5.45543 6.30377 5.22836 6.85195C5.0013 7.40013 4.94189 8.00333 5.05765 8.58527C5.1734 9.16721 5.45912 9.70176 5.87868 10.1213C6.29824 10.5409 6.83279 10.8266 7.41473 10.9424C7.99667 11.0581 8.59987 10.9987 9.14805 10.7716C9.69623 10.5446 10.1648 10.1601 10.4944 9.66671C10.8241 9.17336 11 8.59334 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79565 5 8 5ZM8 8.75C7.85167 8.75 7.70666 8.70601 7.58332 8.6236C7.45999 8.54119 7.36386 8.42406 7.30709 8.28701C7.25033 8.14997 7.23547 7.99917 7.26441 7.85368C7.29335 7.7082 7.36478 7.57456 7.46967 7.46967C7.57456 7.36478 7.7082 7.29335 7.85368 7.26441C7.99917 7.23547 8.14997 7.25032 8.28701 7.30709C8.42406 7.36386 8.54119 7.45999 8.6236 7.58332C8.70601 7.70666 8.75 7.85166 8.75 8C8.75 8.19891 8.67098 8.38968 8.53033 8.53033C8.38968 8.67098 8.19891 8.75 8 8.75Z"
      fill={color}
      style={{
        fill: { color },
        fillOpacity: 1
      }}
    />
  </svg>
);
export default DotOutlineFillIcon;
